export default "__VITE_ASSET__D40rrBx3__"